import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const AnalyticsDataInput = () => {
  const { analyticsId = '' } = useParams();
  const decodedId = analyticsId ? atob(analyticsId) : analyticsId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'analyticsData';

  useEffect(() => {
    if (analyticsId) { setIsEditing(true); fetchDetails(); }
  }, [analyticsId]);

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['analyticsData'] + id + '/', { headers });
      setFormData(response.data);
    } catch (error) { console.error('Error fetching Analytics Data details:', error); }
  };

  const fields = [
    { name: 'metric_name', label: 'Metric Name', type: 'text', required: true },
    { name: 'date', label: 'Date', type: 'date', required: true },
    { name: 'value', label: 'Value', type: 'number', required: true }
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Analytics Data' : 'Create Analytics Data'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} cancelPath="/reporting/analytics/list" />
    </div>
  );
};

export default AnalyticsDataInput;